export default "__VITE_ASSET__5c43101e__"